import { MedicalNotesReportScreen } from "app/screens/residents/show/MedicalNotesReportScreen";
import { useLocalSearchParams } from "expo-router";

export default function MedicalNotesAddPage() {
  const { formId } = useLocalSearchParams();
  const form = Number(formId);
  return <MedicalNotesReportScreen formId={form} />;
}
